import React from 'react'
// import SearchInput from '../SearchInputForEditor/SearchInput'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import ExpertSearchBar from './ExpertSearchBar';

export default function ExpertSearch({onChangeFunc}) {
  const dispatch = useDispatch();
  const editorState = useSelector(state=>state.editor);
  const {updateAnswerTextForEditor} = bindActionCreators(Actions, dispatch);
  const stapleAnswer = (str) =>{
    let newStr = editorState.answerText.concat(str.answerCopy);
    updateAnswerTextForEditor(newStr)
  }
  return (
    <div>
        <ExpertSearchBar onChangeFunc={stapleAnswer} createQa={false}/>
    </div>
  )
}
